<template>
  <!-- Breadcrumb -->
  <v-row>
    <v-col cols="12">
      <v-breadcrumbs
        class="text-caption py-0 px-0"
        :items="viewModel.breadcrumbs"
      >
        <template v-slot:prepend>
          <v-icon icon="mdi-chart-bar" size="small"></v-icon>
        </template>
      </v-breadcrumbs>
    </v-col>
  </v-row>
  <!-- Título -->
  <v-row>
    <v-col cols="12">
      <v-card
        flat
        border
        class="d-flex pa-4 px-8"
        justify="between"
        align="center"
        style="border-left: 7px solid rgb(var(--v-theme-primary), 0.4)"
      >
        <div class="text-subtitle-1 font-weight-bold">Total Aportes:</div>
        <v-spacer></v-spacer>
        <div>
          <strong class="text-subtitle-1 text-success">
            {{ viewModel.formattedTotal.value }}</strong
          >
        </div>
      </v-card>
    </v-col>
  </v-row>

  <!-- Verificar si hay movimientos -->
  <v-row>
    <v-col cols="12" class="pt-0">
      <v-card class="pa-4 rounded-sm" flat border>
        <div v-if="!viewModel.contribution.value?.aportes?.length">
          <v-alert
            type="info"
            class="text-center text-subtitle-2"
            variant="tonal"
            text="No hay movimientos de aportes disponibles."
            border
          />
        </div>

        <!-- Lista de movimientos -->
        <v-list v-else class="overflow-y-auto" max-height="393">
          <v-list-item
            v-for="(mov, index) in viewModel.contribution.value?.aportes"
            :key="'mov-' + index"
            class="pa-4 mb-2 border-b-sm"
            style="border-left: 7px solid rgb(var(--v-theme-primary), 0.4)"
          >
            <template #prepend>
              <v-avatar
                rounded="lg"
                size="48"
                variant="tonal"
                :color="viewModel.getColor(mov.tipomov)"
              >
                <v-icon size="20">{{
                  viewModel.getIconName(mov.tipomov)
                }}</v-icon>
              </v-avatar>
            </template>
            <template #default>
              <v-list-item-title class="text-subtitle-1 font-weight-bold">
                {{ mov.concepto }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-subtitle-2">
                {{ viewModel.formatDateISO(mov.fecha) }}
                {{ viewModel.formatHour(mov.hora) }}
              </v-list-item-subtitle>
            </template>
            <template #append>
              <v-list-item-subtitle
                class="text-subtitle-1 font-weight-bold"
                :class="`text-${viewModel.getColor(mov.tipomov)}`"
              >
                <strong>
                  {{ viewModel.formatCoin(mov.moneda) }}
                  {{ viewModel.formatFloat(mov.total) }}
                </strong>
              </v-list-item-subtitle>
            </template>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
/* import Contribution
 */
import ContributionViewModel from "@/viewmodels/app/ContributionViewModel";

const viewModel = new ContributionViewModel();
</script>
